import { zaokrouhliNc } from '@/main/utils/numbers';

import { store } from '@/main/store';

import { ZAKAZKA_DRUH, ZAKAZKA_STAV, zakazkaStateLocalized, SPLIT_BY, SPLIT_VALUE_MIN, SPLIT_VALUE_MAX } from './constants';

export function getStavZakazka(zakazkaStoreEdit: any): ZAKAZKA_STAV {
	switch (true) {
		case zakazkaStoreEdit.VyrazenPrp: return ZAKAZKA_STAV.VYRAZENA;
		case !!zakazkaStoreEdit.UzavreniDat: return ZAKAZKA_STAV.UZAVRENA;
		case !!zakazkaStoreEdit.UvolneniDat: return ZAKAZKA_STAV.UVOLNENA;
		case !!zakazkaStoreEdit.OtevreniDat: return ZAKAZKA_STAV.OTEVRENA;
		case zakazkaStoreEdit.NabidkaPrp: return ZAKAZKA_STAV.NABIDKA;
		default: return (!store.state.loggedUser.DmsSys.IsPreparationActivePrp ? ZAKAZKA_STAV.OTEVRENA : ZAKAZKA_STAV.V_PRIPRAVE);
	}
}

export function getNextStavZakazka(zakazkaStoreEdit: any, preprationPrp: any) {
	const currentStavZakazka = getStavZakazka(zakazkaStoreEdit);
	if (currentStavZakazka === ZAKAZKA_STAV.NABIDKA) {
		if (zakazkaStoreEdit.ZakazkaId <= 0) {
			return null;
		}
		return preprationPrp ? zakazkaStateLocalized(ZAKAZKA_STAV.V_PRIPRAVE) : zakazkaStateLocalized(ZAKAZKA_STAV.OTEVRENA);
	}
	const finished = currentStavZakazka === ZAKAZKA_STAV.VYRAZENA
		|| (zakazkaStoreEdit.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND && currentStavZakazka === ZAKAZKA_STAV.UZAVRENA);

	return finished ? null : zakazkaStateLocalized(currentStavZakazka + 1);
}

export function getPrevStavZakazka(zakazkaStoreEdit: any) {
	return getStavZakazka(zakazkaStoreEdit) === ZAKAZKA_STAV.UVOLNENA
		? zakazkaStateLocalized(ZAKAZKA_STAV.OTEVRENA) : null;
}

function handleInvalidValues(message: string, objSplitValidation: any) {
	objSplitValidation.displayErrorMessage = true;
	objSplitValidation.isValid = false;
	objSplitValidation.validateMessage = message;
	return objSplitValidation;
}

export function splitValidationCheck(zakazkaStoreEdit: any): any {
	const objSplitValidation = {
		validateMessage: '' as string,
		isValid: true as boolean,
		displayErrorMessage: false as boolean,
	};

	if (!zakazkaStoreEdit.SplitBy || zakazkaStoreEdit.SplitParty.length <= SPLIT_VALUE_MIN) {
		return handleInvalidValues('ErrSelectSplitOption', objSplitValidation);
	}

	const cumulativeShareValue = zakazkaStoreEdit.InsuranceShareValue! + zakazkaStoreEdit.CustomerShareValue! + zakazkaStoreEdit.GoodwillShareValue!;
	const calculatedValue = zaokrouhliNc(cumulativeShareValue, 2);
	if (zakazkaStoreEdit.SplitBy === SPLIT_BY.PERCENTAGE) {
		if (zakazkaStoreEdit.isInsShareVisible && (zakazkaStoreEdit.InsuranceShareValue! < SPLIT_VALUE_MIN
			|| zakazkaStoreEdit.InsuranceShareValue! > SPLIT_VALUE_MAX || zakazkaStoreEdit.InsuranceShareValue === null)) {
			return handleInvalidValues('ErrInsuranceShare', objSplitValidation);
		}
		if (zakazkaStoreEdit.isCustomerShareVisible && (zakazkaStoreEdit.CustomerShareValue! < SPLIT_VALUE_MIN
			|| zakazkaStoreEdit.CustomerShareValue! > SPLIT_VALUE_MAX || zakazkaStoreEdit.CustomerShareValue === null)) {
			return handleInvalidValues('ErrCustomerShare', objSplitValidation);
		}
		if (zakazkaStoreEdit.isGoodwillShareVisible && (zakazkaStoreEdit.GoodwillShareValue! < SPLIT_VALUE_MIN
			|| zakazkaStoreEdit.GoodwillShareValue! > SPLIT_VALUE_MAX || zakazkaStoreEdit.GoodwillShareValue === null)) {
			return handleInvalidValues('ErrGoodwillShare', objSplitValidation);
		}
		if (calculatedValue !== SPLIT_VALUE_MAX) {
			return handleInvalidValues('ErrTotalPercent', objSplitValidation);
		}
	}

	if (zakazkaStoreEdit.SplitBy === SPLIT_BY.AMOUNT) {
		if (zakazkaStoreEdit.isInsShareVisible && (zakazkaStoreEdit.InsuranceShareValue! < SPLIT_VALUE_MIN || zakazkaStoreEdit.InsuranceShareValue! > zakazkaStoreEdit.UnitPrice!)) {
			return handleInvalidValues('ErrInsuranceShare', objSplitValidation);
		}
		if (zakazkaStoreEdit.isCustomerShareVisible && (zakazkaStoreEdit.CustomerShareValue! < SPLIT_VALUE_MIN || zakazkaStoreEdit.CustomerShareValue! > zakazkaStoreEdit.UnitPrice!)) {
			return handleInvalidValues('ErrCustomerShare', objSplitValidation);
		}
		if (zakazkaStoreEdit.isGoodwillShareVisible && (zakazkaStoreEdit.GoodwillShareValue! < SPLIT_VALUE_MIN || zakazkaStoreEdit.GoodwillShareValue! > zakazkaStoreEdit.UnitPrice!)) {
			return handleInvalidValues('ErrGoodwillShare', objSplitValidation);
		}
		if (calculatedValue !== zakazkaStoreEdit.UnitPrice!) {
			return handleInvalidValues('ErrTotalPrice', objSplitValidation);
		}
	}
	return objSplitValidation;
}

/**
 * Prepis z DMS2 HasZakaznickyDoklad. Implementace v dms2 vraci true rovnez pro eVraceniGD, eNabidka, eServis, eServisNabidka
 */
function hasZakaznickyDoklad(zakazkaDruh: ZAKAZKA_DRUH): boolean {
	return [
		ZAKAZKA_DRUH.PRODEJ_PULT,
		ZAKAZKA_DRUH.PRODEJ_ZBOZI,
		ZAKAZKA_DRUH.DROBNE_SLUZBY,
		ZAKAZKA_DRUH.DILENSKA,
		ZAKAZKA_DRUH.KULANCE,
		ZAKAZKA_DRUH.UDRZBA_OV,
		ZAKAZKA_DRUH.ZAPUJCKA,
		ZAKAZKA_DRUH.INTERNI_DILENSKA,
		ZAKAZKA_DRUH.KULANCE,
		ZAKAZKA_DRUH.GARANCE,
	].includes(zakazkaDruh);
}

export function isVozidloSet(zakazkaDruh: ZAKAZKA_DRUH, vozidloId: number) {
	return zakazkaDruh !== ZAKAZKA_DRUH.UDRZBA_OV && hasZakaznickyDoklad(zakazkaDruh) && vozidloId;
}
